import { Container } from 'react-bootstrap';
import '../index.scss';

const Onboard = () => {
  return (
    <div className="prmPage" data-testid="prm-onboard-page">
      <Container>
        <h1 className="Heading Heading--h5">Onboard</h1>
        <p className="Preamble">Onboard will be available here soon.</p>
      </Container>
    </div>
  );
};

export default Onboard;
